import PropTypes from "prop-types";
import { Input, Space, Drawer, Form, Select } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";

const { Option } = Select;
const { TextArea } = Input;

const RejectSlide = (props) => {
  const [form] = Form.useForm();
  const countSelected =
    props.selectedRowKeys?.length > 0 ? props.selectedRowKeys.length : 0;
  let joinSelected =
    props.selectedRowKeys?.length > 0
      ? props.selectedRowKeys.join(",")
      : props.selectedRowKeys;
  let msgSelect = "Rack";
  if (countSelected > 1) {
    joinSelected = "";
    msgSelect = "Racks";
  }

  return (
    <Drawer
      title={
        <span>
          <span>Manifest Rejection</span>{" "}
          <span style={{ color: "#42769a" }}>{joinSelected}</span>{" "}
          <span style={{ color: "#F26469" }}>
            {countSelected} {msgSelect} Selected
          </span>
        </span>
      }
      open={props.isModalVisible}
      onCancel={props.handleCancel}
      onClose={props.handleCancel}
      footer={null}
      closeIcon={<CloseCircleOutlined />}
      className={props.className}
      width={props.width}
    >
      <div className="modal-body">
        <Form
          form={form}
          layout="vertical"
          onFinish={props.handleManifestReject}
          initialValues={""}
        >
          <Form.Item name="bidId" label="Bid ID" hidden>
            <Input />
          </Form.Item>
          <Form.Item
            name="rejectionType"
            label="Rejection Type"
            rules={[{ required: true, message: "Please select a Station!" }]}
            className="rejection-reason-slider"
          >
            <Select placeholder="Select a Station">
              {props.rejectionOptions.map((option) => (
                <Option key={option.id} value={option.id}>
                  {option.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="rejectionReason"
            label="Rejection Reason"
            rules={[{ required: true, message: "Please provide a Reason!" }]}
            className="rejection-reason-slider"
          >
            <TextArea rows={3} className="book-page-form-input-textarea" />
          </Form.Item>
          <div className="modal-footer">
            <Form.Item className="model-action-container">
              <Space>
                <button
                  className="cancel-button-gray-outline"
                  type="button"
                  onClick={props.handleCancel}
                >
                  Cancel
                </button>
                <button
                  className="submit-button-red-outline"
                  type="submit"
                  disabled={props.isDisabled}
                  data-track="manifest-verification-reject"
                >
                  Submit for Rejection
                </button>
              </Space>
            </Form.Item>
          </div>
        </Form>
      </div>
    </Drawer>
  );
};

RejectSlide.propTypes = { 
  selectedRowKeys: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ),
  isModalVisible: PropTypes.bool.isRequired,
 handleCancel: PropTypes.func.isRequired,
  handleManifestReject: PropTypes.func.isRequired,
  rejectionOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  className: PropTypes.string, 
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isDisabled: PropTypes.bool,
};

RejectSlide.defaultProps = {
  selectedRowKeys: [],
  className: "",
  width: 500,
  isDisabled: false,
};

export default RejectSlide;